import React from "react";
// UI Framework
// Common Components
import { CheckBox, FileDownloader, Button, Modal } from "src/Components";
import TableTemplate, {
  IFilterTableCols,
} from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import OrderBook from "./OrderBook";
import SearchParamUI from "./SearchParamUI";
import FilterSettingModal from "./FilterSettingModal";
// Requests
import {
  getConversionOffsetExcel,
  getConversionOffsetTable,
} from "src/Requests/synthetic";
// Types
import {
  ISelectedTableInfo,
  ISyntheticPairPositionTableReport,
  IPairPositionSearchParams,
} from "src/Interfaces/Synthetic";
// Utilities
import * as R from "ramda";

interface IVisibleHeaders {
  all: boolean;
  mediator: boolean;
}

enum ModalMode {
  Closed,
  FilterSetting,
}
const ArtificialPairPosition: React.FC = () => {
  // refs
  const prevRowRef = React.useRef<number | null>(null);
  // local store
  const [modalMode, setModalMode] = React.useState(ModalMode.Closed);
  const [searchParam, setSearchParam] =
    React.useState<IPairPositionSearchParams>({} as IPairPositionSearchParams);
  const [serverSearchParams, setServerSearchParams] =
    React.useState<IPairPositionSearchParams>({} as IPairPositionSearchParams);
  const [selectedTableInfo, setSelectedTableInfo] =
    React.useState<ISelectedTableInfo>({} as ISelectedTableInfo);
  const [visibleHeaders, setVisibleHeaders] = React.useState(
    {} as IVisibleHeaders
  );
  const [refreshFlag, setRefreshFlag] = React.useState(false);

  const changeHandler = (name: string, value: any) => {
    setVisibleHeaders({ ...visibleHeaders, [name]: value } as IVisibleHeaders);
  };

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };
  const handleExcelDownload = () => getConversionOffsetExcel(searchParam);

  const handleSearch = () => {
    const cleanObject = R.pickBy(
      (v) => !(v === null || v === "" || (Array.isArray(v) && v.length === 0)),
      searchParam
    );
    setServerSearchParams(cleanObject as IPairPositionSearchParams);
  };

  const getFilterCols = (): IFilterTableCols => {
    const result: IFilterTableCols = {
      show: true,
      tableName: "artificialPairPositionTable",
      allowedPositions: [],
    };
    if (visibleHeaders.all) result.allowedPositions.push("DefaultHidden");
    if (visibleHeaders.mediator) result.allowedPositions.push("Mediator");
    return result;
  };

  const UIModal = React.useMemo(() => {
    switch (modalMode) {
      case ModalMode.FilterSetting:
        return (
          <FilterSettingModal
            onClose={() => setModalMode(ModalMode.Closed)}
            onApplied={() => setRefreshFlag((prev) => !prev)}
          />
        );
      default:
        return null;
    }
  }, [modalMode]);

  return (
    <>
      {modalMode ? (
        <Modal UI={UIModal} onClose={() => setModalMode(ModalMode.Closed)} />
      ) : (
        <></>
      )}
      <div className="flex flex-col justify-start items-start gap-2 relative pt-5 mx-auto p-8 w-full">
        <div className="flex justify-start items-center w-full">
          <div className="flex flex-row justify-start items-center gap-5">
            <div className="bg-sky-200 rounded py-1 px-2">
              <CheckBox
                checked={visibleHeaders.all}
                label="جزئیات"
                name="all"
                onChange={changeHandler}
              />
            </div>
            <div className="bg-red-200 rounded py-1 px-2">
              <CheckBox
                checked={visibleHeaders.mediator}
                label="محاسبات"
                name="mediator"
                onChange={changeHandler}
              />
            </div>
            <FileDownloader getFile={handleExcelDownload} />
            <Button
              onClick={() => setModalMode(ModalMode.FilterSetting)}
              text="تنظیمات فیلتر"
              variant="outlined"
            />
          </div>
        </div>
        <OrderBook selectedTableInfo={selectedTableInfo} />
        <div className="flex flex-row justify-start items-start gap-1 w-full mt-7 h-fit">
          <SearchParamUI
            searchParam={searchParam}
            searchParamChangeHandler={searchParamChangeHandler}
            onSubmit={handleSearch}
          />
          <div className="border border-gray-300 rounded flex min-w-0 flex-1 justify-center items-center gap-3 overflow-x-hidden">
            <TableTemplate<
              IPairPositionSearchParams,
              ISyntheticPairPositionTableReport
            >
              TableUI={({ reports, onAction, sortingType, setSortingType }) => (
                <CommonTableUI
                  reports={reports}
                  onAction={onAction}
                  filterCols={getFilterCols()}
                  sortingType={sortingType}
                  setSortingType={setSortingType}
                  refreshFlag={refreshFlag}
                  onTableRowClick={(row) => {
                    if (prevRowRef.current === row.id) return;
                    prevRowRef.current = row.id;
                    setSelectedTableInfo({
                      id: row.id,
                      insIds: [
                        row.instrumentId1,
                        row.instrumentId2,
                        row.instrumentId3,
                        row.instrumentId4,
                      ],
                    });
                  }}
                  activeRowId={
                    selectedTableInfo ? selectedTableInfo?.id : undefined
                  }
                  tableBoxClassName="max-h-[500px]"
                  ref={prevRowRef}
                />
              )}
              refreshTableTime={30000}
              getDataTable={getConversionOffsetTable}
              searchParameters={serverSearchParams}
              withSort
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default ArtificialPairPosition;
